<!--
 * @Description: 绑定服务弹框组件
 * @Author: sunhuihong
 * @Date: 2023-02-07 16:43:52
 * @LastEditTime: 2023-11-27 13:43:59
-->
<template>
  <div class="body">
    <el-dialog width="1200px" title="绑定服务" :visible.sync="visible"
      :close-on-click-modal="false" @open="initData" :before-close="handleCancel" center>
      <div v-if="bindingHserviceData && bindingHserviceData.institutionHserviceDTOList 
        && bindingHserviceData.institutionHserviceDTOList.length">
        <div class="binging-hservice-content" >
          <div class="binging-hservice-content-item"  
            v-for="(item, index) in bindingHserviceData.institutionHserviceDTOList" 
            :key="index">
            <div class="head">
		          <div class="blue-line"></div>
		          <span class="title">{{item.institutionName}}</span>
		        </div>
            <el-row :gutter="37" type="flex" style="padding: 0 15px; flex-wrap: wrap;" 
              v-if="item.hserviceList.length">
              <el-col :span="6" v-for="(items, indexs) in item.hserviceList" :key="indexs" 
                style="margin-top: 20px; position: relative;">
                <div @click="handleHsvcItem(items)">
                  <div :class="items.isBinding == 1 ? 'binding-hsvc-style' 
                    : items.isBinding == 0 ? 'no-biding-hsvc-style' : ''">
                    <span class="binding-hservice-name">{{items.name}}</span>
                    <span style="font-size: 12px; line-height: 17px;">{{'￥' + items.price + '起'}}</span>
                  </div>
                  <img class="check-img" :src="items.isBinding == 1 ?  checkImg : items.isBinding == 0 ?
                    noCheckImg : ''"  alt="" />
                  <img v-if="items.status == 0" class="disabled-img" 
                    src="@/assets/common/icon-common-disabled.png" alt="">
                </div>
              </el-col>
            </el-row>
            <el-empty v-else :image-size="100" description="此机构暂无服务"></el-empty>
          </div>
        </div>
        <div class="dialog-footer bk-wizard-bottons" v-if="!showBottomButton">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>
      </div>
      <div  v-else class="binging-hservice-empty">
        <el-empty :image-size="200" description="暂无服务"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
export default {
  name: 'BindingHservice',
  props: ["visible", "hspId"],

  data() {
    return {
      bindingHserviceData: {},
      checkImg: require("@/assets/common/icon-common-check.png"),
      noCheckImg: require("@/assets/common/icon-common-not-check.png"),
      showBottomButton: true,
    }
  },
  
  methods: {
      initData() {
        let params = {hspId: this.hspId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_HOSPITAL_DO4BINDING_HSERVICE,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
			  this.vueRequest(requestData).then(result => {
          if (result == null) {
            return;
          }
          this.bindingHserviceData = result.data || {};
          this.queryShowBottomButton(result.data.institutionHserviceDTOList);
			  })
      },

      //查询当前数据里面是否每一项服务列表数据长度都是0,如果是就不显示底部按钮,反之显示
      queryShowBottomButton(array) {
        if (array.every(target => target.hserviceList.length === 0)) {
          this.showBottomButton = true;
        } else {
          this.showBottomButton = false;
        }   
      },

      handleHsvcItem(item) {
        if (item.isBinding == 0) {
          item.isBinding = 1;
        } else if (item.isBinding == 1) {
          item.isBinding = 0;
        }
      },

      //取消
      handleCancel() {
        this.$emit("close-dialog", false);
      },

      //确定
      handleSubmit() {
        let header = this.encryptionUtil.signatureBody(this.bindingHserviceData,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'POST',
          url: Constant.URL_SAVE_OR_UPDATE_HOSPITAL_HSERVICE,
          param: this.bindingHserviceData,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then(result => {
          if (result == null) {
            return;
          }
          this.$emit("close-dialog", true);
			  })
      }
  },

}
</script>

<style scoped>
.binging-hservice-content {
  margin: 0 25px 60px 25px;
}

.binging-hservice-content-item {
  margin-top: 30px;
}

.binging-hservice-content-item:nth-child(1) {
  margin-top: 5px;
}

.binging-hservice-content-item .head {
  display: flex;
  align-items: center;
}

.binging-hservice-content-item .head .blue-line {
  width: 3px;
  height: 20px;
  background: #3E7EF5;
  margin-right: 15px;
}

.binging-hservice-content-item .head .title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  line-height: 25px;
}

.binding-hsvc-style {
  height: 78px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #3E7EF5;
  padding: 0 15px;
  color: #3E7EF5;
  cursor: pointer;
}

.no-biding-hsvc-style {
  height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #C4CBD4;
  padding: 0 15px;
  color: #000000;
  cursor: pointer;
}

.binding-hservice-name {
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
  font-size: 15px; 
  line-height: 21px;   
}

.check-img {
  position: absolute;
  width: 35px;
  height: 36px;
  bottom: 0;
  right: 0;
  margin-right: 19px;
  cursor: pointer;
}

.disabled-img {
  position: absolute;
  width: 33px;
  height: 16px;
  top: 0;
  left: 0;
  margin-left: 19px;
}

.dialog-footer {
  text-align: center;
}

.binging-hservice-empty {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/hspmng/components/BindingHservice.vue